import { STRING } from 'customer-data-objects/property/PropertyTypes';
export const RICH_TEXT = 'html';
export const isRichTextFieldType = property => {
  return property.type === STRING && property.fieldType === RICH_TEXT;
};